import styles from './FormSkeleton.module.css'

interface FormSkeletonProps {
  /**
   * Etichetta del target dello switch ("Domestico" / "Business").
   * Se valorizzata, sopra lo skeleton compare un banner pulsante
   * "Stai passando a {label}" per dare un feedback chiaro all'operatore
   * che la modalita' del wizard sta cambiando.
   */
  switchingTo?: 'Domestico' | 'Business' | null
}

/**
 * Skeleton loader del wizard pratica, mostrato durante il cambio di
 * percorso (Domestico <-> Business) o durante il primo bootstrap della
 * sessione operatore. Riproduce l'altezza e la struttura del FormSection
 * per evitare salti di layout quando il contenuto reale appare.
 */
export function FormSkeleton({ switchingTo = null }: FormSkeletonProps) {
  return (
    <div
      className={styles.skeletonWrapper}
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label={
        switchingTo
          ? `Caricamento percorso ${switchingTo}`
          : 'Caricamento in corso'
      }
    >
      {switchingTo && (
        <div className={styles.modeBanner}>
          <i
            className={
              switchingTo === 'Business' ? 'bi bi-building' : 'bi bi-house-door'
            }
            aria-hidden
          />
          <span>Stai passando a {switchingTo}…</span>
        </div>
      )}

      {/* Stepper */}
      <div className={styles.stepperRow} aria-hidden>
        <span className={`${styles.stepperDot} ${styles.stepperDotActive}`} />
        <span className={styles.stepperBar} />
        <span className={styles.stepperDot} />
        <span className={styles.stepperBar} />
        <span className={styles.stepperDot} />
        <span className={styles.stepperBar} />
        <span className={styles.stepperDot} />
        <span className={styles.stepperBar} />
        <span className={styles.stepperDot} />
      </div>

      {/* Card form */}
      <div className={styles.card} aria-hidden>
        <div className={styles.cardHeader}>
          <span className={styles.iconSquare} />
          <div className={styles.headerLines}>
            <span className={styles.titleBar} />
            <span className={styles.descBar} />
          </div>
        </div>

        <div className={styles.divider} />

        <div className={styles.fieldGrid}>
          <div className={`${styles.field} ${styles.fullWidth}`}>
            <span className={styles.label} />
            <span className={styles.input} />
          </div>
          <div className={styles.field}>
            <span className={styles.label} />
            <span className={styles.input} />
          </div>
          <div className={styles.field}>
            <span className={styles.label} />
            <span className={styles.input} />
          </div>
          <div className={styles.field}>
            <span className={styles.label} />
            <span className={styles.input} />
          </div>
          <div className={styles.field}>
            <span className={styles.label} />
            <span className={styles.input} />
          </div>
          <div className={`${styles.field} ${styles.fullWidth}`}>
            <span className={styles.label} />
            <span className={styles.input} />
          </div>
        </div>

        <div className={styles.actions}>
          <span className={styles.button} />
          <span className={styles.button} />
        </div>
      </div>
    </div>
  )
}
